module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\n    if ((data.locked || data.bundleLocked) && data.isSearch ) {\n        data.lockIconClass = 'bundle-lock';\n        data.lockGradientClass = 'bundle-lock-gradient';\n        data.isUserSubscriber = CBS.Registry.user_auth && CBS.Registry.user.sub_status !== 'REGISTERED' && CBS.Registry.user.sub_status !== 'EX_SUBSCRIBER'\n    }\n\nlet _href = data.href;\nif (data.isEvent) {\n_href = 'javascript:void(0)';\n}\n\n%>\n\n<a href=\"<%= _href %>\" class=\"ch-expanded-container <%= data.cType %>-expanded-container\" id=\"<%= data.id %>\"     \n    <% if(data.showSeriesTitle && data.cType == 'ch') { %>\n        data-showId=\"<%= data.showId  %>\"\n    <% } %>\n>\n    <div class=\"media-manager-container\"></div>\n\n    <% if (data.cType == 'ch') { %>\n        <% if (data.badgeLabel){ %>\n    <div class=\"new-item-container\">\n        <div class=\"new-item\"><%= data.badgeLabel %></div>\n    </div>\n<% } %>\n    <% } %>    \n\n    <div class=\"<%= data.cType %>-expanded-overlay-components\">\n        <% if(data.carouselType === 'keep-watching' && data.cType == 'ch') { %>\n            <%\nlet _uuid = Math.floor((Math.random() * 1000000) + 1);\nlet progress = data.progress;\n%>\n\n<div class=\"ch-keep-watching-bottom-components\">\n    <% if ((data.seasonNumber && data.episodeNumber && data.genre != 'SPORTS') || data.showEpisodeLabel) { \n        const kwData = {\n            season: data.seasonNumber,\n            episodeNumber: data.episodeNumber\n        }    \n    %>\n        <div class=\"ch-info-wrapper\">\n            <% if (data.seasonNumber && data.episodeNumber && data.isEpisodeless !== true){ %>\n            <div class=\"ch-season-episode-info\">\n                <%= interpolateUrl(getLocale(\"season_episode_abbr\"), kwData) %>\n            </div>\n            <% } %>\n            <div class=\"ch-episode-title\">\n                <%= data.showEpisodeLabel %>\n            </div>\n        </div>\n    <% } %>\n\n    <% if(data.ratingIcon && CBS.Registry.region.international) { %>\n    <div class=\"ch-rating-wrapper\">\n            <img src=\"<%= data.ratingIcon %>\" />\n        </div>\n    <% }else if (data.rating){ %>\n    <div class=\"ch-rating-wrapper\">\n        <span><%= data.rating  %></span>\n    </div>\n    <% } %>\n\n    <div class=\"ch-progress-bar-wrapper\">\n        <%# Progress Bar %>\n        <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n        <div class=\"ch-time-stamp\">\n            <%= data.timeStamp %>\n        </div>\n    </div>\n</div>\n        <% } else if (data.isLive) { %>\n            <%\nlet _uuid = Math.floor((Math.random() * 1000000) + 1);\nlet progress = data.progress;\n%>\n\n<div class=\"ch-live-bottom-components\">\n    <div class=\"<%= data.cType %>-description\">\n        <%= data.about %>\n    </div>\n\n    <% if (!data.isUpcomingListing) { %>\n        <div class=\"ch-progress-bar-wrapper\">\n            <%# Progress Bar %>\n            <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n            <p class=\"ch-progress-text\">\n                <%= data.progressText %>\n            </p>\n        </div>\n    <% } %>\n</div>\n\n<% if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ %>\n    <div class=\"<%= data.cType %>-bundle-locked\">\n        <div class=\"portrait label bundle-lock\">\n            <img src=\"/assets/images/svg/content_lock.svg\"/>\n        </div>\n        <div class=\"<%= data.cType %>-lock-text\"><span><%= getLocale('get_pplus_showtime')%></span></div>\n    </div>\n<% } %>\n        <% } else if (data.model==='videoConfig') { %>\n            <%\n    let _uuid = Math.floor((Math.random() * 1000000) + 1);\n    let progress = data.progress;\n    let hasProgress = data.progress && data.progress > 0;\n    let chClass = hasProgress ? \"video-conf-kw-bottom-components\" : \"ch-bottom-components\";\n%>\n\n<% if (data.cType == 'ch') { %>\n<div class=\"<%= chClass %>\">\n<% } %>\n    <% if(hasProgress){ %>\n        <div class=\"ch-info-wrapper\">\n            <% if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless){ %>\n                <div class=\"ch-season-episode-info\">\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Season <%= data.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= data.seasonNumber %>\">\n                            <%= getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) %>\n                        </abbr>\n                    </span>\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Episode <%= data.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= data.episodeNumber %>\">\n                            <%= getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) %>\n                        </abbr>\n                    </span>\n                    <span class=\"ch-episode-title\"><%= data.title %></span>\n                </div>\n            <% } %>\n        </div>\n\n        <% if(data.ratingIcon && CBS.Registry.region.international) { %>\n            <div class=\"ch-rating-wrapper\">\n                <img src=\"<%= data.ratingIcon %>\" />\n            </div>\n        <% }else if (data.rating){ %>\n            <div class=\"ch-rating-wrapper\">\n                <span><%= data.rating  %></span>\n            </div>\n        <% } %>\n\n        <div class=\"ch-progress-bar-wrapper\">\n            <%# Progress Bar %>\n            <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n            <div class=\"ch-time-stamp\">\n                <%= data.timeStamp %>\n            </div>\n        </div>\n    <% } else { %>\n\n        <div class=\"<%= data.cType %>-info-wrapper\">\n            <!-- START ch related -->\n            <% if (data.cType == 'ch') { %>\n                <% if(data.ratingIcon && CBS.Registry.region.international) { %>\n                    <span class=\"ch-rating\">\n                        <img src=\"<%= data.ratingIcon %>\" />\n                    </span>\n                <% } %>\n                <% if (data.isMovie && typeof(data?.unifiedGenre?.[0]) !== \"undefined\"){ %>\n                    <span><%= data.unifiedGenre[0] %></span>\n                <% } %>\n                <% if (!data.isMovie && data.chAirDate){ %>\n                    <span><%= data.chAirDate %> </span>\n                <% } else if (data.isMovie && data.chAirDateYear) { %>\n                    <span><%= data.chAirDateYear %> </span>\n                <% } %>\n                <% if(data.rating && !CBS.Registry.region.international) { %>\n                    <span><%= data.rating %></span>\n                <% } %>\n                <% if (data.chDuration){ %>\n                    <span><%= data.chDuration %> </span>\n                <% } %>\n            <% } %>\n            <!-- END ch related -->\n        </div>\n\n        <% if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless) { %>\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season <%= data.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= data.seasonNumber %>\">\n                        <%= getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) %>\n                    </abbr>\n                </span>\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode <%= data.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= data.episodeNumber %>\">\n                        <%= getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) %>\n                    </abbr>\n                </span>\n                <span class=\"meta-white meta-white-thin\"><%= data.title %></span>\n            </div>\n        <% } else if(!data.isMovie && data.label) { %>\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white meta-white-semibold\"><%= data.label %></span>\n            </div>\n        <% } %>\n\n        <% if (data.about && data.cType == 'ch'){ %>\n            <div class=\"<%= data.cType %>-description <%= data.lockIconClass %>\">\n                <%= data.about %>\n            </div>\n        <% } %>\n        \n        <% if (data.castNames) { %>\n            <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        <%= getLocale('starring_')%> <%- data.castNames %>\n    </div>\n</div>\n        <% } %>\n        \n        <% if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ %>\n            <div class=\"<%= data.cType %>-bundle-locked\">\n                <div class=\"portrait label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </div>\n                <div class=\"<%= data.cType %>-lock-text\"><span><%= getLocale('get_pplus_showtime')%></span></div>\n            </div>\n        <% } %>\n    <% } %>    \n<% if (data.cType == 'ch') { %>    \n</div>\n<% } %>\n        <% } else { %>\n            <% if (data.cType == 'ch') { %>\n<div class=\"<%= data.cType %>-bottom-components\">\n<% } %>    \n    <div class=\"<%= data.cType %>-info-wrapper\">\n        <!-- check to only show rating if one of the needed values is present -->\n        <%\n        let neededValues = { genre: data.genre, premiereDate: data.premiereDate, seasonCounts: data.seasonCounts, movieDuration: data.movieDuration };\n        let oneNeededValueMet = Object.values(neededValues).some(v => v)\n        %>\n        \n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if ( ((data.locked || data.bundleLocked) && data.isUserSubscriber) || (data.isLocal && data.lockIcon && !data.isUserSubscriber) ) { %>\n            <div class=\"<%= data.lockGradientClass %>\"></div>\n            <div class=\"label <%= data.lockIconClass %>\">\n                <img src=\"<%= data.lockIcon %>\"/>\n            </div>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n        \n        <% if (typeof(data.genre) !== \"undefined\" && data.genre){ %>\n            <span><%= data.genre %></span>\n        <% } %>\n\n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if (data.year){ %>\n            <span><%= data.year %> </span>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        <% if (data.cType == 'ch') { %>\n            <% if (data.premiereDate && data.genre != 'SPORTS'){ %>\n                <span><%= data.premiereDate %> </span>\n            <% } %>\n        <% } %>\n        <!-- END ch related -->\n        \n        <% if ((data.seasonCounts && data.isSeasonless !== true && data.cType == 'ch') || (data.seasonCounts && data.cType == 'prominent')){ %>\n            <span><%= data.numSeasons > 1 ? interpolateUrl(getLocale('_seasons'), {seasonCount: data.numSeasons}).toUpperCase() : getLocale('1_season').toUpperCase() %></span>\n        <% } %>\n        \n        <% if(data.ratingIcon && CBS.Registry.region.international && oneNeededValueMet && data.cType == 'ch') { %>\n            <span class=\"<%= data.cType %>-rating\">\n                <img src=\"<%= data.ratingIcon %>\" />\n            </span>\n        <% }else if ((data.rating && oneNeededValueMet && data.cType == 'ch') || (data.rating && !CBS.Registry.region.international && data.cType == 'prominent')){ %>\n            <span class=\"<%= data.cType %>-rating\"><%= data.rating %></span>\n        <% } %>\n\n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if (data.runtime){ %>\n            <span><%= data.runtime %></span>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n\n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if(data.ratingIcon && CBS.Registry.region.international && data.isMovie) { %>\n            <span class=\"prominent-rating\">\n                        <img src=\"<%= data.ratingIcon %>\" />\n                    </span>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        <% if (data.cType == 'ch') { %>\n            <% if (data.isMovie && data.movieDuration && data.category != 'SPORTS'){ %>\n            <span><%= data.movieDuration %></span>\n            <% } %>\n        <% } %>\n        <!-- END ch related -->\n    </div>\n\n    <!-- START prominent related -->\n    <% if (data.cType == 'prominent') { %>\n        <% if (data.tuneInTime) { %>\n        <div class=\"prominent-tune-in-time-container\">\n            <p class=\"tuneInTime\"> <%= data.tuneInTime %> </p>\n        </div>\n        <% } %>\n    <% } %>\n    <!-- END prominent related -->\n    \n    <% if (data.about && data.cType == 'ch'){ %>\n        <div class=\"<%= data.cType %>-description <%= data.lockIconClass %>\">\n            <%= data.about %>\n        </div>\n    <% } else if (data.about && data.cType == 'prominent') { %>\n        <div class=\"<%= data.cType %>-description\">\n            <p><%= data.about %></p>\n        </div>\n    <% } %>\n    \n    <% if (data.castNames) { %>\n        <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        <%= getLocale('starring_')%> <%- data.castNames %>\n    </div>\n</div>\n    <% } %>\n    \n    <% if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ %>\n        <div class=\"<%= data.cType %>-bundle-locked\">\n            <div class=\"portrait label bundle-lock\">\n                <img src=\"/assets/images/svg/content_lock.svg\"/>\n            </div>\n            <div class=\"<%= data.cType %>-lock-text\"><span><%= getLocale('get_pplus_showtime')%></span></div>\n        </div>\n    <% } %>\n<% if (data.cType == 'ch') { %>    \n</div>\n<% } %>\n        <% } %>\n        <%\ndata.watchlist_active_class = data.contentMyListActive ? 'in_watchlist' : ''\ndata.notify_active_class = data.contentNotificationActive ? 'notify_on' : ''\ndata.play_icon_class = data.button.play ? 'playIcon' : ''\n\ndata.profileType = CBS.Registry.user.profile_type ? CBS.Registry.user.profile_type : '';\nlet isSearch = CBS.Registry.pageType === \"Search\"; \n%>\n<div class=\"highlight-cta-wrapper\">\n    <div class=\"button-container\">\n        <button class=\"button <%=data.play_icon_class%> highlight-play-button <%= (navigator.userAgent.indexOf('Win') != -1 && data.play_icon_class !== '') ? 'buttonWindows' : '' %>\"\n                aria-label=\"<%=data.button.label%>\"\n                button-url=\"<%=data.button.url%>\">\n            <div class=\"button__text\">\n                <span><%=data.button.label%></span>\n            </div>\n        </button>\n        <% if(data.allowMyListControls && !data.scheduleBadge ) { %>\n           \n            <div class=\"button-with-tooltip highlight-watch-list <%=data.watchlist_active_class%> <%=data.contentMyListActive ? 'active' : ''%>\">\n                <button class=\"highlight-watchlist-cta\"\n                    id=\"watchlist-cta-<%=data.id || data.contentId%>\" \n                    aria-label=\"My List Toggle\"\n                    href-add=\"<%=data.contentMyListAddActionUrl%>\"\n                    href-remove=\"<%=data.contentMyListRemoveActionUrl%>\">\n                    <span class=\"watchlist_copy\">&nbsp;</span>\n                </button>\n                <div class=\"<%= (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' %> highlight-tooltip\">\n                    <span class=\"tooltip-text tooltip-add-text\"><%= getLocale('add_to_my_list') %></span>\n                    <span class=\"tooltip-text tooltip-remove-text\"><%= getLocale('remove_from_my_list') %></span>\n                </div>\n            </div>\n            \n            <% if (!CBS.Registry.region.international && data.profileType === 'ADULT') { %>\n                <div class=\"button-with-tooltip highlight-notify <%=data.notify_active_class%> <%=data.contentNotificationActive ? 'active' : ''%>\">\n                    <button class=\"highlight-notify-bell-cta\"\n                        id=\"notify-cta-<%=data.id || data.contentId%>\"\n                        aria-label=\"Notifications Toggle\"\n                        href-add=\"<%=data.contentNotificationAddActionUrl%>\"\n                        href-remove=\"<%=data.contentNotificationRemoveActionUrl%>\"\">\n                        <span class=\"notify_copy\">&nbsp;</span>\n                    </button>\n                    <div class=\"<%= (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' %> highlight-tooltip highlight-tooltip-notify\">\n                        <span class=\"tooltip-text tooltip-add-text\"><%= getLocale('notify_me') %></span>\n                        <span class=\"tooltip-text tooltip-remove-text\"><%= getLocale('turn_off_notifications') %></span>\n                    </div>\n                </div>\n            <% } %>\n        <% } %>\n    </div>\n</div>\n    </div>\n</a>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/expandingContainer.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
    if ((data.locked || data.bundleLocked) && data.isSearch ) {
        data.lockIconClass = 'bundle-lock';
        data.lockGradientClass = 'bundle-lock-gradient';
        data.isUserSubscriber = CBS.Registry.user_auth && CBS.Registry.user.sub_status !== 'REGISTERED' && CBS.Registry.user.sub_status !== 'EX_SUBSCRIBER'
    }

let _href = data.href;
if (data.isEvent) {
_href = 'javascript:void(0)';
}


    ; __line = 13
    ; __append("\n\n<a href=\"")
    ; __line = 15
    ; __append(escapeFn( _href ))
    ; __append("\" class=\"ch-expanded-container ")
    ; __append(escapeFn( data.cType ))
    ; __append("-expanded-container\" id=\"")
    ; __append(escapeFn( data.id ))
    ; __append("\"     \n    ")
    ; __line = 16
    ;  if(data.showSeriesTitle && data.cType == 'ch') { 
    ; __append("\n        data-showId=\"")
    ; __line = 17
    ; __append(escapeFn( data.showId  ))
    ; __append("\"\n    ")
    ; __line = 18
    ;  } 
    ; __append("\n>\n    <div class=\"media-manager-container\"></div>\n\n    ")
    ; __line = 22
    ;  if (data.cType == 'ch') { 
    ; __append("\n        ")
    ; __line = 23
    ;  if (data.badgeLabel){ 
    ; __append("\n    <div class=\"new-item-container\">\n        <div class=\"new-item\">")
    ; __line = 25
    ; __append(escapeFn( data.badgeLabel ))
    ; __append("</div>\n    </div>\n")
    ; __line = 27
    ;  } 
    ; __append("\n    ")
    ; __line = 28
    ;  } 
    ; __append("    \n\n    <div class=\"")
    ; __line = 30
    ; __append(escapeFn( data.cType ))
    ; __append("-expanded-overlay-components\">\n        ")
    ; __line = 31
    ;  if(data.carouselType === 'keep-watching' && data.cType == 'ch') { 
    ; __append("\n            ")
    ; __line = 32
    ; 
let _uuid = Math.floor((Math.random() * 1000000) + 1);
let progress = data.progress;

    ; __line = 35
    ; __append("\n\n<div class=\"ch-keep-watching-bottom-components\">\n    ")
    ; __line = 38
    ;  if ((data.seasonNumber && data.episodeNumber && data.genre != 'SPORTS') || data.showEpisodeLabel) { 
        const kwData = {
            season: data.seasonNumber,
            episodeNumber: data.episodeNumber
        }    
    
    ; __line = 43
    ; __append("\n        <div class=\"ch-info-wrapper\">\n            ")
    ; __line = 45
    ;  if (data.seasonNumber && data.episodeNumber && data.isEpisodeless !== true){ 
    ; __append("\n            <div class=\"ch-season-episode-info\">\n                ")
    ; __line = 47
    ; __append(escapeFn( interpolateUrl(getLocale("season_episode_abbr"), kwData) ))
    ; __append("\n            </div>\n            ")
    ; __line = 49
    ;  } 
    ; __append("\n            <div class=\"ch-episode-title\">\n                ")
    ; __line = 51
    ; __append(escapeFn( data.showEpisodeLabel ))
    ; __append("\n            </div>\n        </div>\n    ")
    ; __line = 54
    ;  } 
    ; __append("\n\n    ")
    ; __line = 56
    ;  if(data.ratingIcon && CBS.Registry.region.international) { 
    ; __append("\n    <div class=\"ch-rating-wrapper\">\n            <img src=\"")
    ; __line = 58
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n        </div>\n    ")
    ; __line = 60
    ;  }else if (data.rating){ 
    ; __append("\n    <div class=\"ch-rating-wrapper\">\n        <span>")
    ; __line = 62
    ; __append(escapeFn( data.rating  ))
    ; __append("</span>\n    </div>\n    ")
    ; __line = 64
    ;  } 
    ; __append("\n\n    <div class=\"ch-progress-bar-wrapper\">\n        ")
    ; __line = 67
    ; __append("\n        ")
    ; __line = 68
    ; __append("\n")
    ; __line = 69
    ; __append("\n")
    ; __line = 70
    ; __append("\n")
    ; __line = 71
    ; __append("\n")
    ; __line = 72
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 75
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-")
    ; __line = 82
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 90
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __line = 92
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 93
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 96
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 104
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 110
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 115
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 119
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 124
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 128
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 133
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 139
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 140
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 142
    ;  } 
    ; __append("\n        <div class=\"ch-time-stamp\">\n            ")
    ; __line = 144
    ; __append(escapeFn( data.timeStamp ))
    ; __append("\n        </div>\n    </div>\n</div>\n        ")
    ; __line = 148
    ;  } else if (data.isLive) { 
    ; __append("\n            ")
    ; __line = 149
    ; 
let _uuid = Math.floor((Math.random() * 1000000) + 1);
let progress = data.progress;

    ; __line = 152
    ; __append("\n\n<div class=\"ch-live-bottom-components\">\n    <div class=\"")
    ; __line = 155
    ; __append(escapeFn( data.cType ))
    ; __append("-description\">\n        ")
    ; __line = 156
    ; __append(escapeFn( data.about ))
    ; __append("\n    </div>\n\n    ")
    ; __line = 159
    ;  if (!data.isUpcomingListing) { 
    ; __append("\n        <div class=\"ch-progress-bar-wrapper\">\n            ")
    ; __line = 161
    ; __append("\n            ")
    ; __line = 162
    ; __append("\n")
    ; __line = 163
    ; __append("\n")
    ; __line = 164
    ; __append("\n")
    ; __line = 165
    ; __append("\n")
    ; __line = 166
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 169
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-")
    ; __line = 176
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 184
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __line = 186
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 187
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 190
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 198
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 204
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 209
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 213
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 218
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 222
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 227
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 233
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 234
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 236
    ;  } 
    ; __append("\n            <p class=\"ch-progress-text\">\n                ")
    ; __line = 238
    ; __append(escapeFn( data.progressText ))
    ; __append("\n            </p>\n        </div>\n    ")
    ; __line = 241
    ;  } 
    ; __append("\n</div>\n\n")
    ; __line = 244
    ;  if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ 
    ; __append("\n    <div class=\"")
    ; __line = 245
    ; __append(escapeFn( data.cType ))
    ; __append("-bundle-locked\">\n        <div class=\"portrait label bundle-lock\">\n            <img src=\"/assets/images/svg/content_lock.svg\"/>\n        </div>\n        <div class=\"")
    ; __line = 249
    ; __append(escapeFn( data.cType ))
    ; __append("-lock-text\"><span>")
    ; __append(escapeFn( getLocale('get_pplus_showtime')))
    ; __append("</span></div>\n    </div>\n")
    ; __line = 251
    ;  } 
    ; __append("\n        ")
    ; __line = 252
    ;  } else if (data.model==='videoConfig') { 
    ; __append("\n            ")
    ; __line = 253
    ; 
    let _uuid = Math.floor((Math.random() * 1000000) + 1);
    let progress = data.progress;
    let hasProgress = data.progress && data.progress > 0;
    let chClass = hasProgress ? "video-conf-kw-bottom-components" : "ch-bottom-components";

    ; __line = 258
    ; __append("\n\n")
    ; __line = 260
    ;  if (data.cType == 'ch') { 
    ; __append("\n<div class=\"")
    ; __line = 261
    ; __append(escapeFn( chClass ))
    ; __append("\">\n")
    ; __line = 262
    ;  } 
    ; __append("\n    ")
    ; __line = 263
    ;  if(hasProgress){ 
    ; __append("\n        <div class=\"ch-info-wrapper\">\n            ")
    ; __line = 265
    ;  if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless){ 
    ; __append("\n                <div class=\"ch-season-episode-info\">\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Season ")
    ; __line = 268
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\">\n                            ")
    ; __line = 269
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) ))
    ; __append("\n                        </abbr>\n                    </span>\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Episode ")
    ; __line = 273
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\">\n                            ")
    ; __line = 274
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) ))
    ; __append("\n                        </abbr>\n                    </span>\n                    <span class=\"ch-episode-title\">")
    ; __line = 277
    ; __append(escapeFn( data.title ))
    ; __append("</span>\n                </div>\n            ")
    ; __line = 279
    ;  } 
    ; __append("\n        </div>\n\n        ")
    ; __line = 282
    ;  if(data.ratingIcon && CBS.Registry.region.international) { 
    ; __append("\n            <div class=\"ch-rating-wrapper\">\n                <img src=\"")
    ; __line = 284
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n            </div>\n        ")
    ; __line = 286
    ;  }else if (data.rating){ 
    ; __append("\n            <div class=\"ch-rating-wrapper\">\n                <span>")
    ; __line = 288
    ; __append(escapeFn( data.rating  ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 290
    ;  } 
    ; __append("\n\n        <div class=\"ch-progress-bar-wrapper\">\n            ")
    ; __line = 293
    ; __append("\n            ")
    ; __line = 294
    ; __append("\n")
    ; __line = 295
    ; __append("\n")
    ; __line = 296
    ; __append("\n")
    ; __line = 297
    ; __append("\n")
    ; __line = 298
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 301
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-")
    ; __line = 308
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 316
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __line = 318
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 319
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 322
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 330
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 336
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 341
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 345
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 350
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 354
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 359
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 365
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 366
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 368
    ;  } 
    ; __append("\n            <div class=\"ch-time-stamp\">\n                ")
    ; __line = 370
    ; __append(escapeFn( data.timeStamp ))
    ; __append("\n            </div>\n        </div>\n    ")
    ; __line = 373
    ;  } else { 
    ; __append("\n\n        <div class=\"")
    ; __line = 375
    ; __append(escapeFn( data.cType ))
    ; __append("-info-wrapper\">\n            <!-- START ch related -->\n            ")
    ; __line = 377
    ;  if (data.cType == 'ch') { 
    ; __append("\n                ")
    ; __line = 378
    ;  if(data.ratingIcon && CBS.Registry.region.international) { 
    ; __append("\n                    <span class=\"ch-rating\">\n                        <img src=\"")
    ; __line = 380
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n                    </span>\n                ")
    ; __line = 382
    ;  } 
    ; __append("\n                ")
    ; __line = 383
    ;  if (data.isMovie && typeof(data?.unifiedGenre?.[0]) !== "undefined"){ 
    ; __append("\n                    <span>")
    ; __line = 384
    ; __append(escapeFn( data.unifiedGenre[0] ))
    ; __append("</span>\n                ")
    ; __line = 385
    ;  } 
    ; __append("\n                ")
    ; __line = 386
    ;  if (!data.isMovie && data.chAirDate){ 
    ; __append("\n                    <span>")
    ; __line = 387
    ; __append(escapeFn( data.chAirDate ))
    ; __append(" </span>\n                ")
    ; __line = 388
    ;  } else if (data.isMovie && data.chAirDateYear) { 
    ; __append("\n                    <span>")
    ; __line = 389
    ; __append(escapeFn( data.chAirDateYear ))
    ; __append(" </span>\n                ")
    ; __line = 390
    ;  } 
    ; __append("\n                ")
    ; __line = 391
    ;  if(data.rating && !CBS.Registry.region.international) { 
    ; __append("\n                    <span>")
    ; __line = 392
    ; __append(escapeFn( data.rating ))
    ; __append("</span>\n                ")
    ; __line = 393
    ;  } 
    ; __append("\n                ")
    ; __line = 394
    ;  if (data.chDuration){ 
    ; __append("\n                    <span>")
    ; __line = 395
    ; __append(escapeFn( data.chDuration ))
    ; __append(" </span>\n                ")
    ; __line = 396
    ;  } 
    ; __append("\n            ")
    ; __line = 397
    ;  } 
    ; __append("\n            <!-- END ch related -->\n        </div>\n\n        ")
    ; __line = 401
    ;  if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless) { 
    ; __append("\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season ")
    ; __line = 404
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\">\n                        ")
    ; __line = 405
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) ))
    ; __append("\n                    </abbr>\n                </span>\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode ")
    ; __line = 409
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\">\n                        ")
    ; __line = 410
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) ))
    ; __append("\n                    </abbr>\n                </span>\n                <span class=\"meta-white meta-white-thin\">")
    ; __line = 413
    ; __append(escapeFn( data.title ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 415
    ;  } else if(!data.isMovie && data.label) { 
    ; __append("\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white meta-white-semibold\">")
    ; __line = 417
    ; __append(escapeFn( data.label ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 419
    ;  } 
    ; __append("\n\n        ")
    ; __line = 421
    ;  if (data.about && data.cType == 'ch'){ 
    ; __append("\n            <div class=\"")
    ; __line = 422
    ; __append(escapeFn( data.cType ))
    ; __append("-description ")
    ; __append(escapeFn( data.lockIconClass ))
    ; __append("\">\n                ")
    ; __line = 423
    ; __append(escapeFn( data.about ))
    ; __append("\n            </div>\n        ")
    ; __line = 425
    ;  } 
    ; __append("\n        \n        ")
    ; __line = 427
    ;  if (data.castNames) { 
    ; __append("\n            <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        ")
    ; __line = 430
    ; __append(escapeFn( getLocale('starring_')))
    ; __append(" ")
    ; __append( data.castNames )
    ; __append("\n    </div>\n</div>\n        ")
    ; __line = 433
    ;  } 
    ; __append("\n        \n        ")
    ; __line = 435
    ;  if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ 
    ; __append("\n            <div class=\"")
    ; __line = 436
    ; __append(escapeFn( data.cType ))
    ; __append("-bundle-locked\">\n                <div class=\"portrait label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </div>\n                <div class=\"")
    ; __line = 440
    ; __append(escapeFn( data.cType ))
    ; __append("-lock-text\"><span>")
    ; __append(escapeFn( getLocale('get_pplus_showtime')))
    ; __append("</span></div>\n            </div>\n        ")
    ; __line = 442
    ;  } 
    ; __append("\n    ")
    ; __line = 443
    ;  } 
    ; __append("    \n")
    ; __line = 444
    ;  if (data.cType == 'ch') { 
    ; __append("    \n</div>\n")
    ; __line = 446
    ;  } 
    ; __append("\n        ")
    ; __line = 447
    ;  } else { 
    ; __append("\n            ")
    ; __line = 448
    ;  if (data.cType == 'ch') { 
    ; __append("\n<div class=\"")
    ; __line = 449
    ; __append(escapeFn( data.cType ))
    ; __append("-bottom-components\">\n")
    ; __line = 450
    ;  } 
    ; __append("    \n    <div class=\"")
    ; __line = 451
    ; __append(escapeFn( data.cType ))
    ; __append("-info-wrapper\">\n        <!-- check to only show rating if one of the needed values is present -->\n        ")
    ; __line = 453
    ; 
        let neededValues = { genre: data.genre, premiereDate: data.premiereDate, seasonCounts: data.seasonCounts, movieDuration: data.movieDuration };
        let oneNeededValueMet = Object.values(neededValues).some(v => v)
        
    ; __line = 456
    ; __append("\n        \n        <!-- START prominent related -->\n        ")
    ; __line = 459
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 460
    ;  if ( ((data.locked || data.bundleLocked) && data.isUserSubscriber) || (data.isLocal && data.lockIcon && !data.isUserSubscriber) ) { 
    ; __append("\n            <div class=\"")
    ; __line = 461
    ; __append(escapeFn( data.lockGradientClass ))
    ; __append("\"></div>\n            <div class=\"label ")
    ; __line = 462
    ; __append(escapeFn( data.lockIconClass ))
    ; __append("\">\n                <img src=\"")
    ; __line = 463
    ; __append(escapeFn( data.lockIcon ))
    ; __append("\"/>\n            </div>\n            ")
    ; __line = 465
    ;  } 
    ; __append("\n        ")
    ; __line = 466
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n        \n        ")
    ; __line = 469
    ;  if (typeof(data.genre) !== "undefined" && data.genre){ 
    ; __append("\n            <span>")
    ; __line = 470
    ; __append(escapeFn( data.genre ))
    ; __append("</span>\n        ")
    ; __line = 471
    ;  } 
    ; __append("\n\n        <!-- START prominent related -->\n        ")
    ; __line = 474
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 475
    ;  if (data.year){ 
    ; __append("\n            <span>")
    ; __line = 476
    ; __append(escapeFn( data.year ))
    ; __append(" </span>\n            ")
    ; __line = 477
    ;  } 
    ; __append("\n        ")
    ; __line = 478
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        ")
    ; __line = 482
    ;  if (data.cType == 'ch') { 
    ; __append("\n            ")
    ; __line = 483
    ;  if (data.premiereDate && data.genre != 'SPORTS'){ 
    ; __append("\n                <span>")
    ; __line = 484
    ; __append(escapeFn( data.premiereDate ))
    ; __append(" </span>\n            ")
    ; __line = 485
    ;  } 
    ; __append("\n        ")
    ; __line = 486
    ;  } 
    ; __append("\n        <!-- END ch related -->\n        \n        ")
    ; __line = 489
    ;  if ((data.seasonCounts && data.isSeasonless !== true && data.cType == 'ch') || (data.seasonCounts && data.cType == 'prominent')){ 
    ; __append("\n            <span>")
    ; __line = 490
    ; __append(escapeFn( data.numSeasons > 1 ? interpolateUrl(getLocale('_seasons'), {seasonCount: data.numSeasons}).toUpperCase() : getLocale('1_season').toUpperCase() ))
    ; __append("</span>\n        ")
    ; __line = 491
    ;  } 
    ; __append("\n        \n        ")
    ; __line = 493
    ;  if(data.ratingIcon && CBS.Registry.region.international && oneNeededValueMet && data.cType == 'ch') { 
    ; __append("\n            <span class=\"")
    ; __line = 494
    ; __append(escapeFn( data.cType ))
    ; __append("-rating\">\n                <img src=\"")
    ; __line = 495
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n            </span>\n        ")
    ; __line = 497
    ;  }else if ((data.rating && oneNeededValueMet && data.cType == 'ch') || (data.rating && !CBS.Registry.region.international && data.cType == 'prominent')){ 
    ; __append("\n            <span class=\"")
    ; __line = 498
    ; __append(escapeFn( data.cType ))
    ; __append("-rating\">")
    ; __append(escapeFn( data.rating ))
    ; __append("</span>\n        ")
    ; __line = 499
    ;  } 
    ; __append("\n\n        <!-- START prominent related -->\n        ")
    ; __line = 502
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 503
    ;  if (data.runtime){ 
    ; __append("\n            <span>")
    ; __line = 504
    ; __append(escapeFn( data.runtime ))
    ; __append("</span>\n            ")
    ; __line = 505
    ;  } 
    ; __append("\n        ")
    ; __line = 506
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n\n        <!-- START prominent related -->\n        ")
    ; __line = 510
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 511
    ;  if(data.ratingIcon && CBS.Registry.region.international && data.isMovie) { 
    ; __append("\n            <span class=\"prominent-rating\">\n                        <img src=\"")
    ; __line = 513
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n                    </span>\n            ")
    ; __line = 515
    ;  } 
    ; __append("\n        ")
    ; __line = 516
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        ")
    ; __line = 520
    ;  if (data.cType == 'ch') { 
    ; __append("\n            ")
    ; __line = 521
    ;  if (data.isMovie && data.movieDuration && data.category != 'SPORTS'){ 
    ; __append("\n            <span>")
    ; __line = 522
    ; __append(escapeFn( data.movieDuration ))
    ; __append("</span>\n            ")
    ; __line = 523
    ;  } 
    ; __append("\n        ")
    ; __line = 524
    ;  } 
    ; __append("\n        <!-- END ch related -->\n    </div>\n\n    <!-- START prominent related -->\n    ")
    ; __line = 529
    ;  if (data.cType == 'prominent') { 
    ; __append("\n        ")
    ; __line = 530
    ;  if (data.tuneInTime) { 
    ; __append("\n        <div class=\"prominent-tune-in-time-container\">\n            <p class=\"tuneInTime\"> ")
    ; __line = 532
    ; __append(escapeFn( data.tuneInTime ))
    ; __append(" </p>\n        </div>\n        ")
    ; __line = 534
    ;  } 
    ; __append("\n    ")
    ; __line = 535
    ;  } 
    ; __append("\n    <!-- END prominent related -->\n    \n    ")
    ; __line = 538
    ;  if (data.about && data.cType == 'ch'){ 
    ; __append("\n        <div class=\"")
    ; __line = 539
    ; __append(escapeFn( data.cType ))
    ; __append("-description ")
    ; __append(escapeFn( data.lockIconClass ))
    ; __append("\">\n            ")
    ; __line = 540
    ; __append(escapeFn( data.about ))
    ; __append("\n        </div>\n    ")
    ; __line = 542
    ;  } else if (data.about && data.cType == 'prominent') { 
    ; __append("\n        <div class=\"")
    ; __line = 543
    ; __append(escapeFn( data.cType ))
    ; __append("-description\">\n            <p>")
    ; __line = 544
    ; __append(escapeFn( data.about ))
    ; __append("</p>\n        </div>\n    ")
    ; __line = 546
    ;  } 
    ; __append("\n    \n    ")
    ; __line = 548
    ;  if (data.castNames) { 
    ; __append("\n        <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        ")
    ; __line = 551
    ; __append(escapeFn( getLocale('starring_')))
    ; __append(" ")
    ; __append( data.castNames )
    ; __append("\n    </div>\n</div>\n    ")
    ; __line = 554
    ;  } 
    ; __append("\n    \n    ")
    ; __line = 556
    ;  if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ 
    ; __append("\n        <div class=\"")
    ; __line = 557
    ; __append(escapeFn( data.cType ))
    ; __append("-bundle-locked\">\n            <div class=\"portrait label bundle-lock\">\n                <img src=\"/assets/images/svg/content_lock.svg\"/>\n            </div>\n            <div class=\"")
    ; __line = 561
    ; __append(escapeFn( data.cType ))
    ; __append("-lock-text\"><span>")
    ; __append(escapeFn( getLocale('get_pplus_showtime')))
    ; __append("</span></div>\n        </div>\n    ")
    ; __line = 563
    ;  } 
    ; __append("\n")
    ; __line = 564
    ;  if (data.cType == 'ch') { 
    ; __append("    \n</div>\n")
    ; __line = 566
    ;  } 
    ; __append("\n        ")
    ; __line = 567
    ;  } 
    ; __append("\n        ")
    ; __line = 568
    ; 
data.watchlist_active_class = data.contentMyListActive ? 'in_watchlist' : ''
data.notify_active_class = data.contentNotificationActive ? 'notify_on' : ''
data.play_icon_class = data.button.play ? 'playIcon' : ''

data.profileType = CBS.Registry.user.profile_type ? CBS.Registry.user.profile_type : '';
let isSearch = CBS.Registry.pageType === "Search"; 

    ; __line = 575
    ; __append("\n<div class=\"highlight-cta-wrapper\">\n    <div class=\"button-container\">\n        <button class=\"button ")
    ; __line = 578
    ; __append(escapeFn(data.play_icon_class))
    ; __append(" highlight-play-button ")
    ; __append(escapeFn( (navigator.userAgent.indexOf('Win') != -1 && data.play_icon_class !== '') ? 'buttonWindows' : '' ))
    ; __append("\"\n                aria-label=\"")
    ; __line = 579
    ; __append(escapeFn(data.button.label))
    ; __append("\"\n                button-url=\"")
    ; __line = 580
    ; __append(escapeFn(data.button.url))
    ; __append("\">\n            <div class=\"button__text\">\n                <span>")
    ; __line = 582
    ; __append(escapeFn(data.button.label))
    ; __append("</span>\n            </div>\n        </button>\n        ")
    ; __line = 585
    ;  if(data.allowMyListControls && !data.scheduleBadge ) { 
    ; __append("\n           \n            <div class=\"button-with-tooltip highlight-watch-list ")
    ; __line = 587
    ; __append(escapeFn(data.watchlist_active_class))
    ; __append(" ")
    ; __append(escapeFn(data.contentMyListActive ? 'active' : ''))
    ; __append("\">\n                <button class=\"highlight-watchlist-cta\"\n                    id=\"watchlist-cta-")
    ; __line = 589
    ; __append(escapeFn(data.id || data.contentId))
    ; __append("\" \n                    aria-label=\"My List Toggle\"\n                    href-add=\"")
    ; __line = 591
    ; __append(escapeFn(data.contentMyListAddActionUrl))
    ; __append("\"\n                    href-remove=\"")
    ; __line = 592
    ; __append(escapeFn(data.contentMyListRemoveActionUrl))
    ; __append("\">\n                    <span class=\"watchlist_copy\">&nbsp;</span>\n                </button>\n                <div class=\"")
    ; __line = 595
    ; __append(escapeFn( (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' ))
    ; __append(" highlight-tooltip\">\n                    <span class=\"tooltip-text tooltip-add-text\">")
    ; __line = 596
    ; __append(escapeFn( getLocale('add_to_my_list') ))
    ; __append("</span>\n                    <span class=\"tooltip-text tooltip-remove-text\">")
    ; __line = 597
    ; __append(escapeFn( getLocale('remove_from_my_list') ))
    ; __append("</span>\n                </div>\n            </div>\n            \n            ")
    ; __line = 601
    ;  if (!CBS.Registry.region.international && data.profileType === 'ADULT') { 
    ; __append("\n                <div class=\"button-with-tooltip highlight-notify ")
    ; __line = 602
    ; __append(escapeFn(data.notify_active_class))
    ; __append(" ")
    ; __append(escapeFn(data.contentNotificationActive ? 'active' : ''))
    ; __append("\">\n                    <button class=\"highlight-notify-bell-cta\"\n                        id=\"notify-cta-")
    ; __line = 604
    ; __append(escapeFn(data.id || data.contentId))
    ; __append("\"\n                        aria-label=\"Notifications Toggle\"\n                        href-add=\"")
    ; __line = 606
    ; __append(escapeFn(data.contentNotificationAddActionUrl))
    ; __append("\"\n                        href-remove=\"")
    ; __line = 607
    ; __append(escapeFn(data.contentNotificationRemoveActionUrl))
    ; __append("\"\">\n                        <span class=\"notify_copy\">&nbsp;</span>\n                    </button>\n                    <div class=\"")
    ; __line = 610
    ; __append(escapeFn( (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' ))
    ; __append(" highlight-tooltip highlight-tooltip-notify\">\n                        <span class=\"tooltip-text tooltip-add-text\">")
    ; __line = 611
    ; __append(escapeFn( getLocale('notify_me') ))
    ; __append("</span>\n                        <span class=\"tooltip-text tooltip-remove-text\">")
    ; __line = 612
    ; __append(escapeFn( getLocale('turn_off_notifications') ))
    ; __append("</span>\n                    </div>\n                </div>\n            ")
    ; __line = 615
    ;  } 
    ; __append("\n        ")
    ; __line = 616
    ;  } 
    ; __append("\n    </div>\n</div>\n    </div>\n</a>\n")
    ; __line = 621
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@7d7ba8afd4bc5ca2bfaf5656bcb870d17e89ab51_fetch-_k4du5uksy5fad7om3lugymerom/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/expandingContainer.tpl"

}